export const PDF_HEADER = {
    pt: [
        {
            datakey: 'name',
            title: 'Pontos de ronda',
        },
        {
            datakey: 'date',
            title: 'Data da leitura',
        },
    ],
    en: [
        {
            datakey: 'name',
            title: 'Patrol Points',
        },
        {
            datakey: 'date',
            title: 'Scanned date',
        },
    ],
}
